import React from "react";
import { AlertTriangle } from "lucide-react";

const NotFound = () => {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="bg-white border border-gray-200 shadow-lg rounded-lg p-6 md:p-10 w-full max-w-lg mx-4 md:mx-0 text-center">
        {/* Icon */}
        <div className="flex justify-center mb-6">
          <div className="bg-orange-100 p-4 rounded-lg">
            <AlertTriangle size={48} className="text-[#FF4C18] animate-pulse" />
          </div>
        </div>

        {/* Heading */}
        <h1 className="text-2xl md:text-3xl font-bold text-gray-900">
          404 - Page Not Found
        </h1>

        {/* Description */}
        <p className="mt-3 text-gray-600 text-sm leading-relaxed">
          Sorry, the page you’re looking for doesn’t exist or has been moved.
          Please check the URL or return to the homepage.
        </p>

        {/* Action Buttons */}
        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <button
            className="px-4 py-2 md:px-6 md:py-2 bg-[#FF4C18] text-white text-sm font-medium rounded-lg shadow-sm hover:bg-orange-600 transition-colors"
            onClick={() => (window.location.href = "/")}
          >
            Return to Home
          </button>
          <button
            className="px-4 py-2 md:px-6 md:py-2 border border-gray-300 text-gray-700 text-sm font-medium rounded-lg hover:bg-gray-100 transition-colors"
            onClick={() => window.history.back()}
          >
            Go Back
          </button>
        </div>

        {/* Footer Note */}
        <p className="mt-6 text-xs text-gray-400">
          © {new Date().getFullYear()} GoPratle. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default NotFound;
